<template>
  <div class="flex items-center text-secondary">
    <span
      class="sr-only"
      role="status"
      aria-live="polite"
    >{{ announcement }}</span>
    <Icon
      height="30px"
      width="30px"
      view-box="0 0 24 24"
    >
      <Timer/>
    </Icon>
    <div
      class="w-20 leading-none mb-1"
      role="timer"
      aria-live="off"
      :aria-label="`${minutes} minutes ${seconds} seconds remaining`"
    >
      <span class="text-2xl text-gray-800 font-medium">{{ formatMinutes }}:{{ formatSeconds }}</span>
    </div>
  </div>
</template>

<script>
import Icon from '@components/Icons/Icon'
import Timer from '@components/Icons/Timer'

import { mapGetters } from 'vuex'

export default {
  components: {
    Icon,
    Timer
  },

  props: {
    deadlineAt: { type: String, default: null },
    serverOffset: { type: Number, default: 0 },
    timeInMinutes: {
      type: Number,
      default: 0
    },
    stop: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      announcement: '',
      lastWarning: null,
      minutes: 0,
      seconds: 0,
      attemptTimeInSeconds: 0,
      interval: null,
      started: false,
      localDeadline: null
    }
  },

  computed: {
    ...mapGetters({
      extraTime: 'attempt/extraTime'
    }),

    /**
     * @return {Number}
     */
    formatMinutes() {
      return String(this.minutes).padStart(2, '0')
    },

    /**
     * @return {Number}
     */
    formatSeconds() {
      if (this.seconds < 10) {
        return '0' + parseInt(this.seconds, 10)
      }
      return this.seconds
    },

    totalExamTimeInSeconds() {
      return this.formatMinutes * 60
    }
  },

  created() {
    const seconds = Number(this.timeInMinutes) * 60 * (this.extraTime ? 1.25 : 1)
    this.localDeadline = Date.now() + seconds * 1000
    this.started = true
    this.interval = setInterval(this.intervalCallback, 250)
    this.intervalCallback()
  },

  mounted() { document.addEventListener('visibilitychange', this.intervalCallback) },
  beforeDestroy() { clearInterval(this.interval); document.removeEventListener('visibilitychange', this.intervalCallback) },

  methods: {
    intervalCallback() {
      if (!this.started) { return }
      const deadline = this.deadlineAt ? Date.parse(this.deadlineAt) : this.localDeadline
      const now = Date.now() + (this.deadlineAt ? this.serverOffset : 0)
      const remaining = Math.max(0, Math.ceil((deadline - now) / 1000))
      this.minutes = Math.floor(remaining / 60)
      this.seconds = remaining % 60
      const warning = remaining <= 60 ? 60 : remaining <= 300 ? 300 : null
      if (warning !== null && warning !== this.lastWarning && remaining > 0) {
        this.lastWarning = warning
        this.announcement = remaining <= 60 ? 'One minute or less remains.' : 'Five minutes or less remain.'
      }
      if (remaining === 0) { this.timerComplete() }
    },

    timerComplete() {
      this.started = false
      clearInterval(this.interval)
      this.announcement = 'Time has ended.'
      this.$emit('time-is-up')
      this.$store.dispatch('attempt/setSpeedCompleted', this.attemptTimeInSeconds)
    }
  }
}
</script>
